<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <form class="form-horizontal" @submit.prevent="handleSubmit">
          <div class="row card-body">
            <div class="col-md-10">
              <div class="card-body">
                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="name">Organization
                    Name</label>
                  <div class="col-sm-7 text-left">
                    <input id="name" v-model="cluster.org_name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('name')}" :disabled="!isAuditor()" class="form-control" data-vv-as="Organization Name" name="name" type="text">
                    <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                      {{
                        errors.first('name') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="org_id">Organization
                    ID</label>
                  <div class="col-sm-7 text-left">
                    <input id="org_id" v-model="cluster.org_id" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('org_id')}" :disabled="!isAuditor()" class="form-control" data-vv-as="Organization ID" name="org_id" type="number">
                    <div v-if="submitted && errors.has('org_id')" class="invalid-feedback">
                      {{
                        errors.first('org_id') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="entity_name">Entity
                    Name</label>
                  <div class="col-sm-7 text-left">
                    <input id="entity_name" v-model="cluster.entity_name" :class="{'is-invalid': submitted && errors.has('entity_name')}" :disabled="!isAuditor()" class="form-control" data-vv-as="Entity Name" name="entity_name" type="text">
                    <div v-if="submitted && errors.has('entity_name')" class="invalid-feedback">
                      {{
                        errors.first('entity_name') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="address">Address</label>
                  <div class="col-sm-7 text-left">
                    <textarea id="address" v-model="cluster.address" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('address')}" :disabled="!isAuditor()" class="form-control" data-vv-as="Address" name="address" rows="4" type="text" />
                    <div v-if="submitted && errors.has('address')" class="invalid-feedback">
                      {{
                        errors.first('address') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="contctPrsn">Contact
                    Person</label>
                  <div class="col-sm-7 text-left">
                    <input id="contctPrsn" v-model="cluster.contact_person" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('contctPrsn')}" :disabled="!isAuditor()" class="form-control" data-vv-as="Contact Person" name="contctPrsn" type="text">
                    <div v-if="submitted && errors.has('contctPrsn')" class="invalid-feedback">
                      {{
                        errors.first('contctPrsn') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="email">Email</label>
                  <div class="col-sm-7 text-left">
                    <input id="email" v-model="cluster.email" v-validate="'required'" :class="{'is-invalid': submitted && error.length>0}" :disabled="!isAuditor()" class="form-control" data-vv-as="Email" name="email" type="text">
                    <div v-if="submitted && error" class="invalid-feedback">
                      {{ error[0] }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="phone_num">Phone
                    No</label>
                  <div class="col-sm-7 text-left">
                    <input id="phone_num" v-model="cluster.phone_num" :class="{'is-invalid': submitted && phnErr.length>0}" :disabled="!isAuditor()" class="form-control" data-vv-as="Phone Number" name="phone_num" type="text">
                    <div v-if="submitted && error" class="invalid-feedback">
                      {{ phnErr[0] }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="cert_ref_id">Certifier
                    Reference ID</label>
                  <div class="col-sm-7 text-left">
                    <input id="cert_ref_id" v-model="cluster.cert_ref_id" :class="{'is-invalid': submitted && errors.has('cert_ref_id')}" :disabled="!isAuditor()" class="form-control" data-vv-as="Certifier Reference ID" name="cert_ref_id" type="text">
                    <div v-if="submitted && errors.has('cert_ref_id')" class="invalid-feedback">
                      {{
                        errors.first('cert_ref_id') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="assessment_start_date">Assessment Start Date</label>
                  <div class="col-sm-7 text-left">
                    <input id="assessment_start_date" v-model="cluster.assessment_start_date" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('assessment_start_date')}" :disabled="!isAuditor()" :max="cluster.assessment_end_date" class="form-control" data-vv-as="Assessment Start Date" name="assessment_start_date" type="date" @change="resetEndDate">
                    <div v-if="submitted && errors.has('assessment_start_date')" class="invalid-feedback">
                      {{ errors.first('assessment_start_date') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="assessment_end_date">Assessment
                    End Date</label>
                  <div class="col-sm-7 text-left">
                    <input id="assessment_end_date" v-model="cluster.assessment_end_date" :class="{'is-invalid': submitted && errors.has('assessment_end_date')}" :disabled="!isAuditor()" :min="cluster.assessment_start_date" class="form-control" data-vv-as="Assessment End Date" name="assessment_end_date" type="date">
                    <div v-if="submitted && errors.has('assessment_end_date')" class="invalid-feedback">
                      {{
                        errors.first('assessment_end_date') }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="geo">Coordinate</label>
                  <div class="col-sm-7 text-left">
                    <textarea id="geo" v-model="cluster.geo_coordinates" :class="{'is-invalid': submitted && errors.has('geo')}" :disabled="!isAuditor()" class="form-control" name="geo" placeholder="Coordinate" rows="4" type="text" />
                    <small class="form-text text-muted">Cluster's geographical coordinate</small>
                    <div v-if="submitted && errors.has('geo')" class="invalid-feedback">
                      {{
                        errors.first('geo') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isAuditor()" class="card-footer">
            <div class="form-group m-b-0 text-right">
              <div class="button-group">
                <button :disabled="!saveShow" class="btn waves-effect waves-light btn-success" type="submit">
                  <span v-if="saveShow">Save</span>
                  <span v-if="!saveShow"><i class="fa fa-spinner fa-spin" /> &nbsp;Loading</span>
                </button>
                <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ViewCluster',
  props: ['auditId', 'auditor', 'events'],
  data () {
    return {
      current_user_role: null,
      error: [],
      phnErr: [],
      map: null,
      tileLayer: null,
      marker: null,
      layers: [],
      farms: [],
      coop: null,
      submitted: false,
      cluster: {
        org_name: '',
        org_id: '',
        entity_name: '',
        address: '',
        contact_person: '',
        email: null,
        phone_num: '',
        cert_ref_id: '',
        assessment_start_date: null,
        assessment_end_date: null,
        geo_coordinates: null
      },
      farmList: [],
      coops: [],
      editorConfig: {
        height: 500
      },
      editorDisabled: null,
      saveShow: true,
      auditors: [],

      is_cluster_added: false
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'activeGroup'])
  },
  watch: {
    auditId: async function (nv, ov) {
      if (nv && nv !== ov) {
        console.log('audit changed')
        await this.getCluster()
      }
    }
  },
  beforeMount () {
    this.init()
  },
  methods: {
    async init () {
      await this.getCluster()
    },

    handleSubmit () {
      console.log(JSON.stringify(this.cluster))
      this.submitted = true
      this.error = []
      this.phnErr = []
      if (!this.cluster.email) {
        this.error.push('Email field required.')
      }
      if (this.cluster.email && !this.validEmail(this.cluster.email)) {
        this.error.push('Valid email required.')
        return
      }
      if (this.cluster.phone_num && !this.validPhoneNum(this.cluster.phone_num)) {
        this.phnErr.push('Valid Phone Number required.')
        return
      }
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save()
          }
        })
    },
    validEmail: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validPhoneNum (phone_num) {
      const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      return re.test(phone_num)
    },
    async save () {
      this.saveShow = false
      try {
        this.cluster.org_id = Number(this.cluster.org_id)
        if (this.is_cluster_added) {
          await this.$api.patch(`/audits/${this.auditId}/clusters`, this.cluster)
        } else {
          await this.$api.post(`/audits/${this.auditId}/clusters`, this.cluster)
        }
        await this.getCluster()
        this.$toastr.s('Info updated', 'Updated!!!')
        this.saveShow = true
      } catch (e) {
        this.$toastr('Updating failed', 'Failed!!!')
        this.saveShow = true
      }
    },
    async getCluster () {
      try {
        const { data } = await this.$api.get(`/audits/${this.auditId}/clusters`)
        if (data) {
          this.cluster = data
          this.is_cluster_added = true
        }
      } catch (e) {
        console.error(e)
      }
    },
    getDataFromEditor (event) {
      this.cluster.editorData = event
    },
    reset () {
      this.submitted = false
      this.cluster.geo.geometry.coordinates = null
      this.cluster = {
        org_name: '',
        org_id: '',
        entity_name: '',
        address: '',
        contact_person: '',
        email: null,
        phone_num: '',
        cert_ref_id: '',
        assessment_start_date: '',
        assessment_end_date: null,
        geo_coordinates: null
      }
    },
    resetEndDate () {
      if (!this.cluster.assessment_start_date) {
        this.cluster.assessment_end_date = ''
      }
    },
    isAuditor () {
      return (this.activeGroup && (this.auditor === this.activeGroup.anonymous_account))
    }
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 600px;
}

.recipient-tag {
  display: inline-block;
  padding: 3px 12px;
  background: #6ab43e;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  text-transform: none;
  font-weight: bold;
}

.recipient-remove {
  padding: 0;
  font-size: 10px;
  margin-left: 5px;
}
</style>
